import { render, staticRenderFns } from "./CustomHighlight.vue?vue&type=template&id=e70e317a"
import script from "./CustomHighlight.vue?vue&type=script&lang=js"
export * from "./CustomHighlight.vue?vue&type=script&lang=js"
import style0 from "./CustomHighlight.vue?vue&type=style&index=0&id=e70e317a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports